import type { ReactNode } from "react";

// Turn plain http(s) URLs inside free-text event fields (body, location,
// meeting point, route note) into clickable links so people don't have to
// select-and-copy on mobile. Returns a mix of strings and <a> nodes; any
// "\n" stays inside the string parts, so callers can keep `whitespace-pre-line`
// to preserve line breaks.

const URL_RE = /(https?:\/\/[^\s<]+)/g;

export function linkify(text: string | null | undefined): ReactNode {
  if (!text) return text;

  const out: ReactNode[] = [];
  let last = 0;

  for (const match of text.matchAll(URL_RE)) {
    const raw = match[0];
    const start = match.index ?? 0;

    if (start > last) out.push(text.slice(last, start));

    // Don't swallow trailing sentence punctuation into the href.
    const href = raw.replace(/[.,;:!?)\]]+$/, "");
    const trailing = raw.slice(href.length);

    out.push(
      <a
        key={start}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-salmon font-semibold underline decoration-salmon/40 underline-offset-2 hover:decoration-salmon break-words"
      >
        {href}
      </a>,
    );
    if (trailing) out.push(trailing);

    last = start + raw.length;
  }

  if (last < text.length) out.push(text.slice(last));

  return out;
}
